import abstractDynamicFieldEntry, { _private as __private } from '../_abstractComponent/DynamicFieldEntry';
import useFormControl from '../../hooks/useFormControl';
__private.useFormControl = useFormControl;
export const _private = __private;
/**
 * Allows creation or update of data needed **for an operation** which will be used LATER
 * to update the given namespace/relation. Useful for creating workflows which update a
 * field of some namespace/relation when some future action happens.
 *
 * This component allows a user to select from a dropdown, at runtime, what type of
 * information (i.e. hNodeType) they would like to change for a given relation (e.g. item:item).
 * That dropdown is then transformed into an input control for the selected hNodeType so
 * the user can actually enter a new value using that input control.
 *
 * It can be used for things like workflows which update a field of some
 * namespace/relation when some future action happens.
 * e.g.
 * 1) A user selects "Asset Type" from the initial dropdown.
 * 2) The dropdown is transformed into another dropdown containing asset types.
 * 3) The user selects the desired asset type from that dropdown.
 * 4) The operation to set this asset type is stored so that it can be executed later when
 * some workflow action requires it.
 *
 * A plus button is provided, allowing multiple entries to be added (so that multiple types
 * of data can be changed with the operation).
 *
 * The list of valid fields for editing is based on the data dictionary for the
 * component's namespace/relation.
 */
export default function DeferredDynamicFieldEntry(props) {
    // Get the stuff needed to store the dynamically selected formElements on the path used
    // by this component (DeferredDynamicFieldEntry) on the activerecord consumed by the form
    // containing this component.
    // e.g. if the current activerecord for our form is:
    // {
    //     namespace: 'ns',
    //     relation: 'rel',
    //     record: {
    //          title: 'some workflow record',
    //          'item:item': [{id: 'metadataId', propertyName: 'customField1'}]
    //     }
    // }
    // and our props.hNode for this component is
    // {
    //     id: 'someId',
    //     hNodeType: 'DeferredDynamicFieldEntry',
    //     hNodeTypeGroup: 'formElement',
    //     foreignNamespace: 'item',
    //     foreignRelation: 'item'
    // }
    // Our entries below will come from (and be updated to) the activeRecord's
    // `record.item:item` property and will contain the hNodes to edit/create the
    // data which the user selects at runtime.
    // e.g. if the user selects "Asset Type" from the Fields dropdown, then the entries
    // will contain an hNode for a dropdown the user may use to select an Asset Type.
    const { value: entries, setValue: setEntries, defaultReady: entriesReady } = __private.useFormControl(props, []);
    return abstractDynamicFieldEntry({ ...props, entries, setEntries, entriesReady });
}
